import axios from '../request/http2';

const oss = {
    //

    getSecret() {
        return axios.get(`/api/v1/credential/oss`);
    },

}

export default oss;